import { combineReducers } from '@reduxjs/toolkit';

import formReducer from './form/slice/formSlice';
import gridReducer from './grid/slice/gridSlice';

const reciboReducer = combineReducers({
  form: formReducer,
  grid: gridReducer,
});

export default reciboReducer;
